// Marco común de Configuración (§1.3): eyebrow, título, subtítulo, acciones y el Seg de
// secciones. El Seg y el eyebrow son solo del superadmin; el admin de turnos ve Farmacias
// sola (§1.7). Textos literales de CFG en maquetas/panel-nuevo.html.
import React from "react";
import { Seg } from "./ui";
import type { AdminRole, AdminView } from "./views";

export type CfgView = Extract<AdminView, `cfg:${string}`>;

const SECTIONS: Array<{ view: CfgView; seg: string; title: string; sub: string }> = [
  { view: "cfg:farmacias", seg: "Farmacias", title: "Farmacias", sub: "El catálogo del Colegio. De acá salen los nombres al cargar turnos." },
  { view: "cfg:plantillas", seg: "Plantillas y letras", title: "Plantillas y letras", sub: "El fondo de los carteles y cómo se acomoda el texto." },
  { view: "cfg:portada", seg: "Portada", title: "Portada del sitio", sub: "Banners, placa, listado, WhatsApp, publicidad y pie de la web pública." },
  { view: "cfg:bot", seg: "Bot", title: "Bot de WhatsApp", sub: "Lo que contesta cuando alguien escribe «farmacia» o «turno»." },
  { view: "cfg:correos", seg: "Correos", title: "Correos", sub: "Lo que llega a la casilla de contacto de la web." },
  { view: "cfg:accesos", seg: "Accesos", title: "Accesos", sub: "Quién entra al panel y medición." },
];

export function ConfigPage({
  view,
  role,
  onNavigate,
  actions,
  children,
}: {
  view: CfgView;
  role: AdminRole;
  onNavigate: (view: CfgView) => void;
  /** botones de la derecha del título (en el celular ocupan el ancho) */
  actions?: React.ReactNode;
  children?: React.ReactNode;
}) {
  const section = SECTIONS.find((s) => s.view === view) ?? SECTIONS[0];
  const isSuper = role === "super";
  return (
    <div className="mx-auto flex max-w-[1160px] flex-col gap-5 md:gap-7">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="flex flex-col gap-1">
          {isSuper && <span className="text-xs font-medium text-adm-acento-texto">Configuración</span>}
          <h1 className="text-[22px] font-semibold leading-tight tracking-[-0.02em] text-adm-text md:text-[26px]">{section.title}</h1>
          <p className="text-[13px] leading-[1.55] text-adm-t55">{section.sub}</p>
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2 max-md:w-full max-md:[&>*]:flex-1">{actions}</div>
        )}
      </div>
      {isSuper && (
        <Seg<CfgView>
          label="Secciones de Configuración"
          value={view}
          onChange={onNavigate}
          options={SECTIONS.map((s) => ({ value: s.view, label: s.seg }))}
        />
      )}
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
